import { useEffect, useState } from "react";
import { Paper, IconButton, InputBase } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";

export const TextFilter = ({
  value,
  onChange,
  placeholder,
  className,
  isLoading = false,
  writeSearchDataToSessionStorage,
  storageValue,
}) => {
  const [internalValue, setInternalValue] = useState(value || "");
  const [isFieldFocused, setIsFieldFocused] = useState(false);

  useEffect(() => {
    setInternalValue(value || "");
  }, [value]);

  const handleChange = (value) => {
    onChange(value);
    writeSearchDataToSessionStorage && writeSearchDataToSessionStorage(storageValue, value);
  };

  const clearValue = () => {
    setInternalValue("");
    onChange("");
    writeSearchDataToSessionStorage?.(storageValue, "");
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <InputBase
        className={className}
        sx={{
          padding: "0px",
          flex: 1,
          fontSize: "16px",
          backgroundColor: isFieldFocused ? "var(--white)" : "inherit",
        }}
        disabled={isLoading}
        placeholder={isFieldFocused ? "" : placeholder}
        value={internalValue}
        onBlur={() => setIsFieldFocused(false)}
        onChange={(event) => {
          setInternalValue(event.target.value);
        }}
        onKeyUp={(event) => {
          if (event.key === "Enter") {
            handleChange(event.target.value);
          }
        }}
        inputRef={(input) => input}
      />
      {isLoading ? (
        <CircularProgress />
      ) : internalValue ? (
        <IconButton type="button" aria-label="clean search" onClick={clearValue} sx={{ padding: "0", mr: "0px" }}>
          <ClearIcon sx={{ fontSize: 22 }} />
        </IconButton>
      ) : (
        <IconButton
          type="button"
          aria-label="search"
          sx={{ padding: "0", mr: "0px" }}
          onClick={() => setIsFieldFocused((prev) => !prev)}
        >
          <SearchIcon />
        </IconButton>
      )}
    </Paper>
  );
};
